import React from "react";

import DeleteModal from "../../../Components/Common/DeleteModal";

import ServerPaginatedTable from "../../../Components/Common/ServerPaginatedTable";
import { API_RESERVATIONS_CANCELED, getDataFromUrl } from "../../../api";
import moment from "moment";

const UserDetailReservationCancelList = (props) => {
    const [data, setData] = React.useState([]);
    const [previous, setPrevious] = React.useState("");
    const [next, setNext] = React.useState("");
    const [count, setCount] = React.useState("");

    const onRequestData = (_url) => {
        getDataFromUrl(_url)
            .then((data) => {
                setData(data.results);
                setPrevious(data.previous);
                setNext(data.next);
                setCount(data.count);
                // if (isSearch) calcTotalPageCount(data.count, (data.results).length);
            })
            .catch((e) => {
                console.log(e);
            });
    };

    React.useEffect(() => {
        if (!previous && !next) {
            getDataFromUrl(`${API_RESERVATIONS_CANCELED}/?search=${props.userPhoneNum}`)
                .then((data) => {
                    // console.log(data);
                    setData(data.results);
                    setPrevious(data.previous);
                    setNext(data.next);
                    setCount(data.count);
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    }, []);

    const [order, setOrder] = React.useState([]);

    const [deleteModal, setDeleteModal] = React.useState(false);
    const [deleteModalMulti, setDeleteModalMulti] = React.useState(false);

    const checkedAll = () => {
        const checkall = document.getElementById("checkBoxAll");
        const ele = document.querySelectorAll(".customerCheckBox");

        if (checkall.checked) {
            ele.forEach((ele) => {
                ele.checked = true;
            });
        } else {
            ele.forEach((ele) => {
                ele.checked = false;
            });
        }
    };

    const columns = React.useMemo(
        () => [
            {
                Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
                Cell: (cellProps) => {
                    return <input type="checkbox" className="customerCheckBox form-check-input" value={cellProps.row.original.id} />;
                },
                id: "#",
            },
            // {
            //   Header: 'ID',
            //   accessor: 'id',
            //   id: 'id',
            // },
            {
                Header: "번호",
                accessor: "row_number",
                id: "",
            },
            // fields = ["예약신청일", "예약상품", "자리", "예약자", "번호", "취소일", "취소금액", "결제상태", "승인번호", "취소사유", "row_number"]
            {
                Header: "예약신청일",
                accessor: "예약신청일",
                id: "order__order_date",
                Cell: (cellProps) => {
                    return <span>{moment(cellProps.row.original["예약신청일"]).format("YYYY-MM-DD HH:mm")}</span>;
                },
            },
            {
                Header: "예약일",
                accessor: "예약일",
                id: "start_date",
            },
            {
                Header: "고객번호",
                accessor: "번호",
                id: "order__user__phone_num",
            },
            {
                Header: "예약상품",
                accessor: "예약상품",
                id: "spot__package__name",
            },
            {
                Header: "취소일",
                accessor: "취소일",
                id: "cancel_date",
                Cell: (cellProps) => {
                    return <span>{moment(cellProps.row.original["취소일"]).format("YYYY-MM-DD HH:mm")}</span>;
                },
            },
            {
                Header: "취소금액",
                accessor: "취소금액",
                id: "canceled_amount",
            },
            {
                Header: "결제방법",
                accessor: "method",
                id: "method",
            },
            {
                Header: "승인번호",
                accessor: "승인번호",
                id: "",
            },
            {
                Header: "취소사유",
                accessor: "취소사유",
                id: "cancel_reason",
            },
            // {
            //   Header: 'Actions',
            //   accessor: 'Actions',
            //   id: '',
            // },
        ],
        []
    );

    const onClickDelete = (order) => {
        setOrder(order);
        setDeleteModal(true);
    };

    const handleDeleteOrder = () => {
        if (order) {
            setDeleteModal(false);
        }
    };

    return (
        <div>
            <DeleteModal show={deleteModal} onDeleteClick={handleDeleteOrder} onCloseClick={() => setDeleteModal(false)} />
            <DeleteModal
                show={deleteModalMulti}
                onDeleteClick={() => {
                    // deleteMultiple();
                    setDeleteModalMulti(false);
                }}
                onCloseClick={() => setDeleteModalMulti(false)}
            />

            <React.Fragment>
                <ServerPaginatedTable
                    id="reservations-table"
                    url={API_RESERVATIONS_CANCELED}
                    columns={columns}
                    data={data}
                    previous={previous}
                    next={next}
                    count={count}
                    onRequestData={onRequestData}
                    serachable={false}
                    categories={[]}
                />
            </React.Fragment>
        </div>
    );
};

export default UserDetailReservationCancelList;
